import styled, { css } from 'styled-components';

export const Button = styled.button`
  ${({ $primary, theme }) => css`
    background: ${$primary ? theme.colors.primary : 'transparent'};
    color: ${$primary ? '#fff' : theme.colors.primary};
    padding: 12px 30px;
    border: 2px solid ${theme.colors.primary};
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
    
    &:hover {
      background: ${$primary ? theme.colors.primary : '#fff'};
      color: ${$primary ? '#fff' : theme.colors.primary};
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  `}
`;